import React from 'react';
import Hero from './Hero';
import About from './About';
import Projects from './Projects';

const Home: React.FC = () => {
  return (
    <>
      <Hero />
      <About />
      <Projects />
    </>
  );
};

export default Home;
